export default function initScrollEffects() {
    const body = document.body;

    // Parallax Effect
    window.addEventListener('scroll', () => {
        const scroll = window.pageYOffset;
        document.documentElement.style.setProperty('--cdr-scroll-parallax', scroll * 0.5);
    });

    // Dark Section Detection Observer
    const sections = document.querySelectorAll('section, footer');
    const observerOptions = {
        threshold: 0.1,
        rootMargin: "-100px 0px -50% 0px"
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const id = entry.target.id;
                const isDark = (id === 'vibe' || entry.target.tagName === 'FOOTER');
                if (isDark) {
                    body.classList.add('body--in-dark-section');
                } else {
                    body.classList.remove('body--in-dark-section');
                }
            }
        });
    }, observerOptions);

    sections.forEach(section => observer.observe(section));
}
